import React, {Component} from "react";
import {Link} from "react-router-dom";
import SportsNews from "../../constants/SportsNews";
import MomentDate from "../../components/MomentDate";
import ImageLoader from 'react-imageloader';
import ImageLoading from "../../components/ImageLoading";
import {connect} from "react-redux";

class NewsItem extends Component {

	preloader() {
		return <ImageLoading/>;
	}

	render() {
		const {data, type, sports} = this.props;
		const img = `http://old.maxline.by/assets/images/news/${data.img}`;
		const link = `/news/${type}/${data.url}`;

		const isViewed = data.id in this.props.viewedNews;

		return (
			<div className={`news__list__items__item ${type === 'site' && !isViewed && 'unviewed'}`}>
				<div className="news__list__items__item-image">
					<Link to={link}>
						<ImageLoader src={img} preloader={this.preloader}/>
					</Link>
				</div>
				<div>
					<div className="news__content-sport">
						<Link to={''}>{SportsNews[data.cat_id]}</Link>
					</div>
					<div className="news__content-date">
						<MomentDate date={data.date} withTitle={true}/>
					</div>
					<div className="news__content-title">
						<Link to={link}>{data.title}</Link>
					</div>
					<div className="news__content-desc">{data.description}</div>
				</div>
			</div>
		);
	}
}

export default connect(
	state => ({
		viewedNews : state.viewedNews,
	}),
	dispatch => ({})
)(NewsItem);


// WEBPACK FOOTER //
// ./src/app/pages/News/NewsItem.js